import { Box } from '@bigcommerce/big-design';
import styled from 'styled-components';

const StyledBox = styled(Box)`
    margin: 0 auto;
    max-width: ${({ theme }) => theme.breakpointValues.desktop}};
    padding: 0 ${({ theme }) => theme.spacing.medium};
`;

export default function Container({ children }) {
    return <StyledBox>{children}</StyledBox>;
}
